module.exports = __webpack_public_path__ + "media/assets/images/rain_sometime_will_sunny-9b2d632b3febba8fe44f2e1500e45910.png";